import { z } from 'zod'
import { oc } from '@orpc/contract'

// Tiny read for the VCC drawer (accounting-plan Task 16): the org's Stripe publishable
// key, so the frontend can mount Elements. The org comes from the encounter
// (serviceProvider, with the PractitionerRole fallback); an org without Stripe
// configured → 400 with the copay-style message.
export const billingV2VccContext = oc
  .route({ method: 'GET', path: '/v2/billing/vcc/context/{encounterId}' })
  .input(z.object({ encounterId: z.string() }))
  .output(z.object({ publishableKey: z.string() }))
